$(document).ready(function () {
  $('.faq-item').on('click',function () {
    $(this).find('.faq-item-content').slideToggle();
    $(this).find('.faq-item-head').toggleClass('active');
  } )
});